import IconOrders from 'components/icons/IconOrders';
import IconProtectionPlans from 'components/icons/IconProtectionPlans';
import IconNotifications from 'components/icons/IconNotifications';
import IconPersonalInformation from 'components/icons/IconPersonalInformation';
import IconQuotes from 'components/icons/IconQuotes';
// import IconDesignServices2 from 'components/icons/IconDesignServices2';
import IconReviews from 'components/icons/IconReviews';
import IconGiftCardAndRewards from 'components/icons/IconGiftCardAndRewards';

const customerDashboardLinks = [
  {
    label: 'Orders',
    path: '/customer/orders/',
    description: 'Thanks for being a Joybird customer.',
    icon: IconOrders,
  },
  {
    label: 'Protection Plans',
    path: '/customer/protection-plans/',
    description: 'Protect your investments.',
    icon: IconProtectionPlans,
  },
  {
    label: 'Quotes',
    path: '/quote/',
    description: 'View and manage your quotes.',
    icon: IconQuotes,
  },
  {
    label: 'Notifications',
    path: '/customer/notifications/',
    description: 'Control when we notify you.',
    icon: IconNotifications,
  },
  {
    label: 'Personal Information',
    path: '/customer/account-update/',
    description: 'Contact info and Password Reset.',
    icon: IconPersonalInformation,
  },

  // {
  //   label: 'Design Services',
  //   path: '/customer/design-services/',
  //   description: 'Your custom designs from us.',
  //   icon: IconDesignServices2,
  // },
  {
    label: 'Reviews',
    path: '/customer/my-reviews/',
    description: 'Give feedback, and get $ rewards!',
    icon: IconReviews,
  },
  {
    label: 'Gift Cards + Credits',
    path: '/customer/rewards-summary/',
    description: 'Activate and manage your gift cards.',
    icon: IconGiftCardAndRewards,
  },
];

const navLinks = [
  {
    label: 'Dashboard',
    path: '/customer/dashboard/',
  },
  ...customerDashboardLinks.map(({ label, path }) => ({
    label,
    path,
  })),
];

export { navLinks };
export default customerDashboardLinks;
